import React, { useState, useContext } from 'react'
import * as AuthAPI from '../services/authAPI';
import AuthContext from '../context/AuthContext';
import Field from '../components/Field';

export default function LoginPage({ navigate }) {

    const { setIsAuthenticated, setRole } = useContext(AuthContext);

    const [credentials, setCredentials] = useState({
            username: "",
            password: ""
    });

    const [error, setError] = useState("");

    const handleChange = ({ currentTarget }) => {
            const { value, name } = currentTarget;
            setCredentials({...credentials, [name]: value});
    };

    const handleSubmit = async event => {
        event.preventDefault();
        try {
            await AuthAPI.authenticate(credentials);
            setError("");
            const tokenData = AuthAPI.setup();
            setRole(tokenData?.role ?? null);
            setIsAuthenticated(true);
            navigate("/", { replace: true });
        } catch (error) {
            setCredentials({username: "", password: ""});
            if (error.roleNotAllowed) {
                setError("Votre rôle ne vous permet pas d'accéder à cette page");
            } else if (error.status === 401 && error.message === "Invalid credentials.") {
                setError("E-mail ou mot de passe incorrect");
            } else if (error.status === 401) {
                setError(error.message);
            } else {
                setError("Service indisponible");
            }
        }
    }

    return (
        <>
			<section className="vh-100">
				<div className="container py-5 h-100">
					<div className="row d-flex justify-content-center align-items-center h-100">
					<div className="col-12 col-md-8 col-lg-6 col-xl-5">
						<div className="card shadow-2-strong">
						    <div className="card-body p-5 text-center">
                                <h3 className="mb-5">Monitor</h3>
                                    <Field 
                                        name="username"
                                        label="Adresse électronique"
                                        value={credentials.username}
                                        onChange={handleChange}
                                        type="email"
                                        error={error}
                                    />
                                    <Field
                                        name="password"
                                        label="Mot de passe"
                                        value={credentials.password}
                                        onChange={handleChange}
                                        type="password"
                                        error={error}
                                    />
                                    <div className="row mb-4">
                                        <a href="#!" onClick={e => { e.preventDefault(); navigate('/forgot-password'); }}>Mot de passe oublié ?</a>
                                    </div>
                                    {error && <p className="text-danger text-center">{error}</p>}
                                    <div className="row">
                                        <button onClick={handleSubmit} className="col-md btn btn-primary">Connexion</button>
                                    </div>
                            </div>
						</div>
					</div>
					</div>
				</div>
			</section>
        </>
    )
}